module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column--one-third-static center img--140px",
    on: {
      "click": function($event) {
        _vm.startAnimation()
      }
    }
  }, [_c('img', {
    staticClass: "block-pa pointer",
    attrs: {
      "alt": "hangul block",
      "src": ("/static/images/hangul-blocks/" + _vm.blockName + "-" + _vm.currentFrame + ".svg")
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40a57957","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HangulBlock.vue
// module id = 142
// module chunks = 0